import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DollarSign, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="pricing" ref={ref} className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-16 px-4" data-id="element-196">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center" data-id="element-197">
        <div className="bg-slate-800 rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-700" data-id="element-198">
          <div className="mb-8" data-id="element-199">
            <p className="text-lg text-slate-400 mb-2" data-id="element-200">Total Value:</p>
            <p className="text-4xl md:text-5xl font-bold text-slate-500 line-through mb-4" data-id="element-201">
              $562
            </p>
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-202">
              <DollarSign className="w-8 h-8 text-orange-400" data-id="element-203" />
              <p className="text-6xl md:text-7xl font-bold text-orange-400" data-id="element-204">
                17
              </p>
            </div>
            <p className="text-xl text-slate-300 mb-2" data-id="element-205">
              One-time payment. Lifetime access.
            </p>
          </div>

          <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-6 mb-8" data-id="element-206">
            <div className="flex items-start gap-3" data-id="element-207">
              <Zap className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" data-id="element-208" />
              <p className="text-lg text-slate-200 text-left" data-id="element-209">
                <span className="font-semibold" data-id="element-210">Why so cheap?</span> Because I
                believe no dog should suffer and no owner should feel trapped.
                But this "Launch Price" will return to $97 very soon.
              </p>
            </div>
          </div>

          <motion.a href="https://floctiva.com/cart/53021114695996:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center gap-2 bg-gradient-to-b from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white font-extrabold text-xl md:text-2xl px-12 py-6 rounded-full shadow-[0_10px_40px_rgba(249,115,22,0.5)] w-full md:w-auto transition-all duration-300 animate-pulse cursor-pointer text-center ring-4 ring-orange-500/30 hover:ring-orange-500/50" data-id="element-211">
            <Zap className="w-6 h-6 fill-white" data-id="element-212" />
            YES! GET INSTANT ACCESS FOR $17
          </motion.a>
        </div>
      </motion.div>
    </section>;
}